import { create } from "zustand";

// "What's new": the updates panel, the unread updates (badge) and the one-time spotlight card
// for a big launch.
export const useWhatsNewStore = create((set) => ({
  isOpen: false,
  unread: [],
  spotlight: null,
  setUnread: (unread) => set({ unread }),
  setSpotlight: (spotlight) => set({ spotlight }),
  open: () => set({ isOpen: true, spotlight: null }),
  close: () => set({ isOpen: false }),
}));
